import { message } from "antd";
import get from "lodash/get";
import isObject from "lodash/isObject";
import React from "react";

export const dateFormatList = ["DD/MM/YYYY", "YYYY-MM-DD"];

export const degreeList = {
  "vi": [
    { "key": "prof-dr", "name": "Giáo sư, Tiến sĩ" },
    { "key": "assoc-prof-dr", "name": "Phó Giáo sư, Tiến sĩ" },
    { "key": "prof", "name": "Giáo sư" },
    { "key": "dr", "name": "Tiến sĩ" }
  ],
  "en": [
    { "key": "prof-dr", "name": "Professor, Doctor" },
    { "key": "assoc-prof-dr", "name": "Asscociate Professor, Doctor" },
    { "key": "prof", "name": "Professor" },
    { "key": "dr", "name": "Doctor" }
  ]
};

export const infoList = {
  school_ranking: "school_ranking",
  thesis_member: "thesis_member",
  thesis_result: "thesis_result",
  instructor_detail: "instructor_detail",
  prizes_v2: "prizes_v2",
  monograph: "monograph",
  scientific_article: "scientific_article",
  science_mission: "science_mission",
  science_prize: "science_prize",
  diploma: "diploma",
  commercialization_mission: "commercialization_mission",
};

export const deepClone = (item) => JSON.parse(JSON.stringify(item ?? ""));

export const compareFunc = ({
  itemA,
  itemB,
  fieldName = null,
  direction = "desc",
}) => {
  if (fieldName) {
    if (itemA[fieldName] > itemB[fieldName])
      return direction === "asc" ? 1 : -1;
    if (itemA[fieldName] < itemB[fieldName])
      return direction === "asc" ? -1 : 1;
    return 0;
  } else {
    if (itemA > itemB) return direction === "asc" ? 1 : -1;
    if (itemA < itemB) return direction === "asc" ? -1 : 1;
    return 0;
  }
};

export const downloadFileFromUrl = (url) => {
  if (typeof url === "string" && url?.includes("http")) {
    window.open(url, "_blank");
  }
};

export const textStyle = (size = 14, weight = 400, color = "#000000") => {
  return {
    fontSize: size,
    fontWeight: weight.toString(),
    color: color,
  };
};
export const dynamicSort = (property) => {
  var sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    /* next line works with strings and numbers,
     * and you may want to customize it to your needs
     */
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
};

export const findKeyInObjectR = (obj, findingKey) => {
  // Nếu obj là string, trả về obj
  if (typeof obj === "string") return obj;
  // Duyệt tất cả field của obj, nếu tìm thấy findingKey, trả về value tương ứng
  const message = get(obj, findingKey);
  if (message !== undefined) {
    return message;
  }
  // Nếu obj không có key nào là findingKey, duyệt từng key
  for (let key in obj) {
    // nếu obj[key] là object, đệ quy hàm này để tìm value của findingKey
    if (isObject(obj[key])) {
      const message = findKeyInObjectR(obj[key], findingKey);
      if (message) {
        return message;
      }
    }
  }
  return "";
};

export const logMessageDirect = (msg, useAntMessage = true) => {
  return handleLogMessage(msg, useAntMessage);
};

export const logMessage = (error, useAntMessage = true) => {
  let msg = "";
  if (typeof error?.response?.data?.message === "string") {
    msg = error.response.data.message;
  } else if (typeof error?.data?.message === "string") {
    msg = error.data.message;
  } else if (typeof error?.message === "string") {
    msg = error.message;
  } else {
    msg = findKeyInObjectR(error, "message");
  }

  return handleLogMessage(msg, useAntMessage);
};

const handleLogMessage = (msg, useAntMessage) => {
  if (!msg?.includes?.(`\n`)) {
    if (useAntMessage) message.error(msg);
    else return msg;
  } else {
    const newMsg = msg?.split(`\n`);
    const msgElement = (
      <div className="w-full flex flex-col items-center">
        {newMsg?.map((i) => (
          <span key={i}>{i}</span>
        ))}
      </div>
    );
    if (useAntMessage) {
      message.error(msgElement);
    } else {
      return msgElement;
    }
  }
};

export const scrollHorizontallyOnScroll = (event, refToScroll) => {
  event.preventDefault();
  refToScroll.scrollLeft += event.deltaY;
};
// Không được import biến từ constant vì file constant đang import từ file này
// Import vòng tròn gây lỗi

export const containsUppercase = (str) => /[A-Z]/.test(str);

export const containsSpecialCharacter = (str) =>
  /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(str);

export const convertDetailData = (responseData) => {
  const convertedData = responseData.map((obj) => {
    const { id, ...attributes } = obj;
    return { id, attributes };
  });

  return convertedData;
};

export const useViewport = () => {
  const [width, setWidth] = React.useState(window.innerWidth);

  React.useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  // Return the width so we can use it in our components
  return { width };
};

export const isStrEmpty = (str) => {
  return !str || /^\s*$/.test(str);
};

export const isValidEmail = (email) => {
  // Simple email validation using a regular expression
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const isValidPhoneNumber = (phoneNumber) => {
  // Simple phone number validation using a regular expression
  const phoneNumberRegex = /^0\d{9}$/;
  return phoneNumberRegex.test(phoneNumber);
};
